import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, of } from 'rxjs';
import { map, first, catchError } from 'rxjs/operators';
import { UsersService } from '../../views/users/users.service';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
  constructor(private userService: UsersService, private router: Router, private snackbar: MatSnackBar) {}

  private extractRoleNames(payload: any): string[] {
    if (Array.isArray(payload)) {
      return payload;
    }

    if (Array.isArray(payload?.roles)) {
      return payload.roles;
    }

    return [];
  }

  /**
   * Returns the full list of role names for a user (single API call).
   * Used by ThemeService to resolve the active role theme without
   * making one request per role.
   */
  getUserRoleNames(userId: string): Observable<string[]> {
    return this.userService.getUserRolesForAuth(userId).pipe(
      first(),
      map((payload: any) => this.extractRoleNames(payload)),
      catchError(() => of([]))
    );
  }

  isAdminOrEboAdmin(userId: string): Observable<boolean> {
    return this.userService.getUserRolesForAuth(userId).pipe(
      first(),
      map((payload: any) => {
        const roleNames = this.extractRoleNames(payload);
        if (roleNames.some((name: string) => name === 'Admin' || name === 'EboAdmin')) {
          return true;
        } else {
          this.router.navigate(['/settings/view']);
          return false;
        }
      }),
      catchError(() => {
        this.router.navigate(['/settings/view']);
        this.snackbar.open(`Error: Unable to check user roles`, 'Dismiss', { duration: 3000 });
        return of(false);
      })
    );
  }

  isAdminClient(userId: string): Observable<boolean> {
    return this.userService.getUserRolesForAuth(userId).pipe(
      first(),
      map((payload: any) => {
        const roleNames = this.extractRoleNames(payload);
        return roleNames.some((name: string) => name === 'Admin-client');
      }),
      catchError(() => {
        this.router.navigate(['/settings/view']);
        this.snackbar.open(`Error: Unable to check user roles`, 'Dismiss', { duration: 3000 });
        return of(false);
      })
    );
  }
}
